<template>
  <SfBannerBase
    v-bind="{ ...$props, ...$attrs }"
    level="system"
    @close="handleClose"
  >
    <template #default>
      <slot />
    </template>
    <template #actions>
      <slot name="actions" />
    </template>
    <template #link>
      <slot name="link" />
    </template>
  </SfBannerBase>
</template>
<script setup lang="ts">
import type { BannerVariant } from '@app/shared/types/banner'
import { bannerVariants } from '@app/shared/types/banner'

import SfBannerBase from './sf-banner-base.vue'
import type { BannerIconType } from './constants'

defineOptions({
  name: 'SfBannerSystem',
})

interface Props {
  autoCloseAfter?: number
  hasLongText?: boolean
  iconClass?: BannerIconType
  isFullWidth?: boolean
  selfManaged?: boolean
  showClose?: boolean
  title?: string
  variant: BannerVariant
}

withDefaults(defineProps<Props>(), {
  autoCloseAfter: undefined,
  hasLongText: false,
  iconClass: '',
  isFullWidth: false,
  title: '',
  variant: bannerVariants.info,
})

const emit = defineEmits(['close'])

const handleClose = (): void => {
  emit('close')
}
</script>
